// Single source of truth for how a scans folder's name is rendered.
//
// Folders are derived from rubrics, so each folder carries the rubric's `type`
// field. MCQs (OMR) folders read identically to subjective ones otherwise, so
// we append " MCQs" to the title to make the distinction obvious wherever a
// folder card shows up — Scans tab, Sort folder grid, Check One Sheet picker,
// Students list folder picker, MCQs > OMR folder grid, etc.
function paperTypeOf(record) {
  // Same characters the watcher strips before it builds a Windows folder
  // name, so the card, Export, and the local folder stay one string.
  return String(record?.paper_type || record?.paperType || '')
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Student lists are stored under the course subject ("URDU"). Words typed in
// "Only for more Papers" (Obj, Sub, or the saved paper type) are not part of
// that course, so "URDU Obj" matches the list "URDU".
export function subjectForListMatch(subject, paperType) {
  let s = String(subject || '').trim();
  const paper = paperTypeOf({ paper_type: paperType });
  if (paper) {
    const tail = new RegExp(`\\s+${paper.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*$`, 'i');
    const cut = s.replace(tail, '').trim();
    if (cut) s = cut;
  }
  const cut = s.replace(/\s+(?:obj|sub)\s*$/i, '').trim();
  return cut || s;
}

export function sameClassAndSubject(folder, list) {
  const norm = (value) => String(value || '').trim().toLowerCase();
  if (norm(folder && folder.class) !== norm(list && list.class)) return false;
  const folderSubject = subjectForListMatch(folder && folder.subject, folder && (folder.paper_type || folder.paperType));
  const listSubject = subjectForListMatch(list && list.subject, '');
  return norm(folderSubject) === norm(listSubject) && norm(folderSubject) !== '';
}

export function folderDisplayTitle(folder) {
  if (!folder) return '';
  const base = String(folder.title || '').trim();
  const paper = paperTypeOf(folder);
  const withPaper = [base, paper].filter(Boolean).join(' ');
  // Tolerant of the field being missing — older API payloads don't include
  // `type` at all, in which case we treat the folder as subjective.
  return folder.type === 'mcq' ? `${withPaper} MCQs` : withPaper;
}

// "10A+10B - CHEMISTRY Mid Term Oct 23, 2026"
// Paper type sits between the subject and the date. An empty paper type
// leaves the name as class, subject, and date.
export function rubricNameWithDate(record, dateStr) {
  if (!record) return '';
  const cls = String(record.class || '').trim();
  const sub = String(record.subject || '').trim();
  const base = cls && sub
    ? `${cls} - ${sub}`
    : String(record.title || cls || sub || '').trim();
  const paper = paperTypeOf(record);
  return [base, paper, String(dateStr || '').trim()].filter(Boolean).join(' ');
}
